"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _OtpDeliveryMethodStepResponse = _interopRequireDefault(require("../../api/auth/OtpDeliveryMethodStepResponse"));
var _ReturnToLoginLink = _interopRequireDefault(require("./ReturnToLoginLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
class OtpDeliveryMethodStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      deliveryMethod: '',
      deliveryMethods: [],
      errorMessage: ''
    };
    this.returnToLogin = this.returnToLogin.bind(this);
  }
  componentDidMount() {
    const {
      stepResponse
    } = this.props;
    const deliveryMethods = stepResponse?.additionalData;
    if (deliveryMethods) {
      this.setState({
        deliveryMethods
      });
    }
  }
  validate(deliveryMethod) {
    const {
      deliveryMethods
    } = this.state;
    let isValid = false;
    deliveryMethods.forEach(dm => {
      if (dm.uid === deliveryMethod) {
        isValid = true;
      }
    });
    return isValid;
  }
  submit(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _OtpDeliveryMethodStepResponse.default();
    step.uuid = this.state.deliveryMethod;
    this.props.listener(this, step);
  }
  change(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  returnToLogin(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.listener('InitializeAuthentication', null);
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  render() {
    const {
      rawErrorMessage,
      isLoading,
      deliveryMethods,
      deliveryMethod
    } = this.state;
    const disabled = !this.validate(deliveryMethod) && !rawErrorMessage;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "otpForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title"
    }, "Security Code"), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-2 has-text-weight-semibold"
    }, "Select where to send your security code"), /*#__PURE__*/_react.default.createElement(_core.Row, null, /*#__PURE__*/_react.default.createElement(_core.Columns, null, /*#__PURE__*/_react.default.createElement(_core.Column, {
      className: "has-text-left"
    }, /*#__PURE__*/_react.default.createElement("div", null, "Please note that you should select only text-enabled phone numbers and that by selecting a ", /*#__PURE__*/_react.default.createElement("span", {
      class: "has-text-weight-semibold"
    }, "number that is text-enabled"), ", you agree that this text notification is subject to MissionSquare Retirement's", /*#__PURE__*/_react.default.createElement("a", {
      href: ""
    }, "Text Access Terms and Conditions"), ".")), /*#__PURE__*/_react.default.createElement(_core.Column, {
      className: "has-text-left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, deliveryMethods.map(dm => /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-text-left pl-2",
      key: `delivery_method_${dm.uid}`
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "is-size-4"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `radio ${rawErrorMessage && 'is-danger'} mr-1`,
      type: "radio",
      id: `delivery_method_${dm.uid}`,
      name: "deliveryMethod",
      onChange: e => this.change(e),
      onBlur: e => this.change(e),
      value: dm.uid,
      required: true
    }), dm.maskedDestination)))))))), decorateErrorMessage(rawErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Next"))), /*#__PURE__*/_react.default.createElement(_ReturnToLoginLink.default, {
      returnToLogin: this.returnToLogin
    }))));
  }
}
OtpDeliveryMethodStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  stepResponse: _propTypes.default.any,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(OtpDeliveryMethodStep);
//# sourceMappingURL=OtpDeliveryMethodStep.js.map